import { TooltipContentProps } from "recharts"
import { translateSeriesName } from "@/common/utils/seriesNameTranslator"
import { barChartLabelFormatter } from "@/common/utils/barChartLabelFormatter"
import { ChartData } from "@/common/types/chart.type"

type customTooltipProps = TooltipContentProps<any, any> & {
  seriesSettings: ChartData["series_settings"]
}

export const CustomChartTooltip = ({ active, payload, label, seriesSettings }: customTooltipProps) => {
  if (!active || !payload?.length) return null

  const filteredPayload = payload.filter(item => item?.value !== null && item.value !== 0)

  if (!filteredPayload.length) return null

  return (
    <div className="bg-slate-300 rounded-lg px-3 py-2 text-[12px] text-black shadow-[0_2px_6px_rgba(0,0,0,0.15)] space-y-1">
      <p className="font-semibold" data-testid="chart_tooltip_label">
        {label}
      </p>

      {filteredPayload.map((item, i) => {
        const name = String(item.name ?? "")
        const rawValue = item.value
        const value = Array.isArray(rawValue) ? rawValue[0] : (rawValue ?? 0)

        return (
          <div key={i} className="flex items-center">
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: item.color }} />

            <span data-testid={`chart_tooltip_value_${name}`}>
              {translateSeriesName(name)}:{" "}
              {barChartLabelFormatter(value, seriesSettings[name]?.format_parser)}
            </span>
          </div>
        )
      })}
    </div>
  )
}

export default CustomChartTooltip

